import { render } from "./EncyclopediaEntryCard.vue?vue&type=template&id=1931d8e5&scoped=true"
import script from "./EncyclopediaEntryCard.vue?vue&type=script&lang=js"
export * from "./EncyclopediaEntryCard.vue?vue&type=script&lang=js"

import "./EncyclopediaEntryCard.vue?vue&type=style&index=0&id=1931d8e5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1931d8e5"]])

export default __exports__